import React from 'react';
import {
  Box,
  IconButton,
  Tooltip,
  Badge,
  alpha,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import {
  Brightness4,
  Brightness7,
  Notifications,
  Settings,
} from '@mui/icons-material';
import useSettings from '../hooks/useSettings';
import WalletConnector from './WalletConnector';

interface NavbarToolsProps {
  showNotifications?: boolean;
  showSettings?: boolean;
  showThemeToggle?: boolean;
  showWallet?: boolean;
}

const NavbarTools: React.FC<NavbarToolsProps> = ({
  showNotifications = true,
  showSettings = true,
  showThemeToggle = true,
  showWallet = true,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const { themeMode, toggleTheme } = useSettings();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {/* Notification button - only shown on non-small screens */}
 {/*      {showNotifications && !isSmallScreen && (
        <Tooltip title="Notifications">
          <IconButton
            color="inherit"
            sx={{ color: theme.palette.text.primary }}
          >
            <Badge badgeContent={0} color="error">
              <Notifications />
            </Badge>
          </IconButton>
        </Tooltip>
      )} */}

      {/* Settings button - only shown on desktop */}
{/*       {showSettings && !isMobile && (
        <Tooltip title="Settings">
          <IconButton
            color="inherit"
            sx={{ color: theme.palette.text.primary }}
          >
            <Settings />
          </IconButton>
        </Tooltip>
      )} */}

      {/* Theme toggle button */}
      {showThemeToggle && (
        <Tooltip title={themeMode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>
          <IconButton 
            color="inherit" 
            onClick={toggleTheme}
            sx={{
              color: theme.palette.text.primary,
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                transform: 'rotate(180deg)',
              },
            }}
          >
            {themeMode === 'dark' ? 
              <Brightness7 sx={{ color: '#ffd700' }} /> : 
              <Brightness4 sx={{ color: '#1976d2' }} />
            }
          </IconButton>
        </Tooltip>
      )}

      {/* Wallet connector component */}
      {showWallet && <WalletConnector />}
    </Box>
  );
};

export default NavbarTools;